import { useEffect } from 'react';

/**
 * P0 · Landing — THE designed marketing page is the static `landing.html`
 * (= bicport.com), shipped in `public/` and served at `/` by the deploy Caddy.
 * The SPA never renders its own landing design: any client-side hit on the
 * `/` route forwards to that page (base-aware, so the /preview demo gets
 * /preview/landing.html). Full page load is intended — it's a separate page.
 */
export function Landing() {
  useEffect(() => {
    window.location.replace(`${import.meta.env.BASE_URL}landing.html`);
  }, []);
  return (
    <div style={{ minHeight: '100vh', background: '#0d2622' }} aria-hidden="true" />
  );
}
